import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={55} height={81} viewBox="0 0 55 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M54.25.75v15.099l-.07.15-29.776 63.818-.2.433H3.19l.502-1.068 28.53-60.817H.75V.75h53.5z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
